// employees/EmployeeContext.js
import { archiveDocumentApi,getAllDocumentApi,getAllDocumentTypeApi,getDocumentStatsApi,getGroupedDocumentsApi,restoreDocumentApi } from "api/services/documents";
import { Bounce,toast } from "react-toastify";
import { format } from "date-fns";
import { createContext,useCallback,useContext,useEffect,useMemo,useRef,useState } from 'react';
import { useMediaQuery } from "react-responsive";
import { useLocation,useNavigate,useParams,useSearchParams } from 'react-router-dom';
import { filterHandler } from 'utils/common';
import { defaultPagination,handlePageChange } from "utils/table";
import useDocumentFilter from "../hooks/filterHook";
import { EXPANDED_ALL, flattenGroups, isGrouped } from "../components/grouping";


							
									  

// Params the stats endpoint ignores (it strips the expiry filters server-side),
// dropped client-side too so the stats request key only changes when something
// that can change the counts does; a tile click then costs no extra request.
const STATS_IGNORED_PARAMS = ["sort_by", "sort_type", "group_by", "expiry_date_after", "expiry_date_before", "expiry_in", "expiry_status", "expired_status"]

const toastOptions = { position: "top-right", autoClose: 4000, transition: Bounce }

// Create the Document context
const documentContext = createContext();

// Custom hook for accessing Document context easily
export const useDocument = () => {
  return useContext(documentContext); 
};

// DocumentProvider component to wrap around components needing access to Resume data
export const DocumentProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    let params = useParams()
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const location = useLocation();

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [documentModal, setDocumentModal] = useState(false);
  const [ selectedDocument, setSelectedDocument] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  // A page of groups from /documents/grouped/ while grouping is on.
  const [documentGroups, setDocumentGroups] = useState([]);
  const [groupCollapse, setGroupCollapse] = useState(EXPANDED_ALL);
  // Flips after the provider's first fetch; see resetDocumentList.
  const initialisedRef = useRef(false);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [storeType, setStoreType] = useState(window.location.pathname.includes("store") ? "store" : "user");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [documentType, setDocumentType] = useState([])
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false)

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_by") || "",
    document_type: searchParams.get("document_type") ,
    // document_sub_type: searchParams.get("document_sub_type") ,
    user: searchParams.get("company_user"),
    groupBy: searchParams.get("group_by") || ""

    //document_type=user&document_sub_type=passport&user=1&issue_date_after=2025-10-28&issue_date_before=2025-10-29&expiry_date_after=2025-10-30&expiry_date_before=2025-10-30&sort_type=ascend&sort_by=issue_date&expiry_in=365
})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange, handleClearAll,
    applyFilterValues,
    isFilterDirty, setIsFilterDirty} = useDocumentFilter(pageSettings , setPageSettings, documentType);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params

})

// Column sort plus, while the table is grouped, group_by so the server keeps
// rows (and the export) in group order. The grid always shows a flat list.
const getSortParams = useCallback(() => ({
  sort_by: pageSettings?.sortBy || "",
  sort_type: pageSettings?.sortType || "",
  ...(view !== "grid" && isGrouped(pageSettings?.groupBy) ? { group_by: pageSettings.groupBy } : {}),
}), [pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.groupBy, view])

const getExportParams = useCallback(() => {
  let filter_params = getFilterParams()
  if (filter_params?.issue_date_after) {
    filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
  }
  if (filter_params?.issue_date_before) {
    filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
  }
  if (filter_params?.expiry_date_after) {
    filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
  }
  if (filter_params?.expiry_date_before) {
    filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
  }
  return {
    ...getSortParams(),
    document_type: pageSettings?.document_type,
    document_sub_type: pageSettings?.document_sub_type,
    company_user: pageSettings?.user || pageSettings?.userData,
    document_type__type: storeType,
    ...filter_params,
  }
}, [filters, pageSettings, storeType, getSortParams])

const setDocumentParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...(pageData?.groupBy ? { group_by: pageData.groupBy } : {}),
        ...filter_params
    }
    setSearchParams(params)
}



    const getDocumentList = useCallback(() => {
        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


          
        const grouped = view !== "grid" && isGrouped(pageSettings?.groupBy)
        const params = {
          ...getSortParams(),
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          document_type: pageSettings?.document_type,
          document_sub_type: pageSettings?.document_sub_type,
          company_user: pageSettings?.user || pageSettings?.userData,
          document_type__type: storeType,
          ...filter_params
        }
        const request = grouped
          ? getGroupedDocumentsApi({ ...params, group_by: pageSettings.groupBy })
          : getAllDocumentApi(params)
        request.then(response=>{
          if (grouped) {
            // A page of groups; the flat copy keeps detail-page prev/next working.
            setDocumentGroups(response.data.results)
            setDocumentData(flattenGroups(response.data.results))
          } else {
            setDocumentGroups([])
            if(view=="grid" && pageSettings?.page!==1){
              setDocumentData([...documentData,...response.data.results]);
            }else{
              setDocumentData(response.data.results);
            }
          }

          setPageSettings(prev => ({
            ...prev,
            total: response.data.count
          }))
    
          setLoading(false)
          setFilterLoading(false)
        }).catch(e=>{
          setLoading(false)
          setFilterLoading(false)
        })
    }, [pageSettings, storeType, view, documentData, getFilterParams])
  useEffect(()=>{

    getDocumentList()
    initialisedRef.current = true

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.groupBy, pageSettings?.filters, pageSettings?.user, pageSettings?._resetTimestamp, storeType])

  useEffect(()=>{
    setDocumentParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    setDocumentTypeLoading(true)
    getAllDocumentTypeApi({type:storeType}).then(response=>{
      setDocumentType(response.data.results)
      setDocumentTypeLoading(false)
    }).catch(e=>{
      setDocumentTypeLoading(false)
    })
  },[storeType])

  // Expiry summary tiles. Refetched with the same scope as the list (search,
  // type, employee, cost centre...) but not on page/sort changes; the server
  // ignores the expiry filters themselves so every bucket stays populated
  // while the list is narrowed to one of them.
  const [documentStats, setDocumentStats] = useState(null)
  const [statsLoading, setStatsLoading] = useState(false)
  const statsRequestRef = useRef(0)
  const statsKeyRef = useRef(null)
  const statsInflightRef = useRef(false)
  const statsPendingRef = useRef(false)

  const getStatsParams = useCallback(() => {
    const params = { ...getExportParams() }
    STATS_IGNORED_PARAMS.forEach(key => { delete params[key] })
    return params
  }, [getExportParams])

  const getDocumentStats = useCallback((force = false) => {
    const params = getStatsParams()
    const key = JSON.stringify(params)
    if (!force && key === statsKeyRef.current) return
    if (statsInflightRef.current && key === statsKeyRef.current) {
      // Same scope already on the wire; a forced refresh runs once it lands.
      if (force) statsPendingRef.current = true
      return
    }
    // A different scope (store vs user documents, other filters) must not
    // keep showing the previous numbers while the new ones load.
    if (key !== statsKeyRef.current) setDocumentStats(null)
    statsKeyRef.current = key
    statsInflightRef.current = true
    const requestId = ++statsRequestRef.current
    setStatsLoading(true)
    const settle = () => {
      statsInflightRef.current = false
      if (statsPendingRef.current) {
        statsPendingRef.current = false
        getDocumentStats(true)
      }
    }
    getDocumentStatsApi(params).then(response => {
      if (requestId !== statsRequestRef.current) return
      setDocumentStats(response.data)
      setStatsLoading(false)
      settle()
    }).catch(() => {
      if (requestId !== statsRequestRef.current) return
      statsKeyRef.current = null // let the next trigger retry
      setDocumentStats(null)
      setStatsLoading(false)
      settle()
    })
  }, [getStatsParams])

  useEffect(() => {
    getDocumentStats()
  }, [pageSettings?.filters, pageSettings?.user, storeType])

  // Coming back from a detail page (where the document may have been edited)
  // needs fresh counts even though the scope is unchanged.
  useEffect(() => {
    if (pageSettings?._resetTimestamp) getDocumentStats(true)
  }, [pageSettings?._resetTimestamp])

  // After a create/delete both the rows and the tiles are stale.
  const refreshDocuments = () => {
    getDocumentList()
    getDocumentStats(true)
  }

  // Archive / restore instead of delete. Refreshes rows and tiles on success
  // and resolves with the response so callers (detail page) can refetch too.
  const setDocumentArchived = (id, archived) => {
    const request = archived ? archiveDocumentApi(id) : restoreDocumentApi(id)
    return request.then((response) => {
      toast.success(archived ? "Document archived." : "Document restored.", toastOptions)
      refreshDocuments()
      return response
    }).catch((e) => {
      toast.error(
        e?.response?.data?.error || (archived ? "Could not archive the document." : "Could not restore the document."),
        toastOptions
      )
      throw e
    })
  }

  // What the list was last fetched with, from the URL; the tiles highlight
  // from this rather than from the drawer's unapplied draft.
  const appliedExpiryFilters = useMemo(() => ({
    expiry_status: searchParams.get("expiry_status") || "",
    expiry_in: searchParams.get("expiry_in") || "",
  }), [searchParams])

  const handleApplyFilter = () => {
    setShowFilterDrawer(false)
    setIsFilterDirty(false)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGroupByChange = (groupBy) => {
    setGroupCollapse(EXPANDED_ALL)
    setPageSettings(prev => ({
      ...prev,
      groupBy: groupBy || "",
      page: 1,
    }))
  }

  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  };

  // The tables no longer let antd paginate: a grouped page holds many more
  // rows than groups, and antd would slice the rows down to `pageSize`. The
  // pager is rendered separately, so sorting and paging arrive apart.
  const handleSortChange = (sorter) => {
    const sortBy = sorter?.field
    const sortType = sorter?.order
    setPageSettings(prev => ({
      ...prev,
      page: (prev.sortBy !== sortBy || prev.sortType !== sortType) ? 1 : prev.page,
      sortBy,
      sortType,
    }))
  }

  const handleTablePageChange = (page, pageSize) => {
    setPageSettings(prev => ({
      ...prev,
      page: pageSize !== prev.pageSize ? 1 : page,
      pageSize,
    }))
  }
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }



  const handleDocumentDetailPage = (id, index) => {			  
    // Include type in query params to maintain navigation state
    const typeParam = storeType === 'store' ? 'type=store' : 'type=user';
    navigate(`/documents/${id}?${typeParam}`)
    setSelectedPage(index)
  }



  const resetDocumentList = useCallback(() => {
    // Pages call this on mount. On a fresh load the provider is about to
    // fetch with exactly this state, so resetting would only fire every
    // request (list and stats) twice.
    if (!initialisedRef.current) return
    setDocumentData([])
    setDocumentGroups([])
    const companyUserParam = searchParams.get("company_user");
    const newPageSettings = {
      ...defaultPagination,
      page: searchParams.get("page") || 1,
      pageSize: searchParams.get("size") || 50,
      sortType: searchParams.get("sort_type") || "",
      sortBy: searchParams.get("sort_by") || "",
      document_type: searchParams.get("document_type") || null,
      // document_sub_type: searchParams.get("document_sub_type") ,
      user: companyUserParam || null,
      groupBy: searchParams.get("group_by") || "",
      total: 0
    }
    // Use functional update and add a timestamp to force re-render
    setPageSettings(prev => ({
      ...newPageSettings,
      _resetTimestamp: Date.now() // Force update to trigger useEffect
    }))
  }, [searchParams])

  // Reset document list when navigating to documents list page
  useEffect(() => {
    // Check if we're on the documents list page (not detail page)
    const isDocumentListPage = location.pathname === '/documents' || location.pathname === '/documents/';
    const isStoreDocumentsPage = location.pathname === '/documents/store' || location.pathname === '/documents/store/';
    
    if (isDocumentListPage || isStoreDocumentsPage) {
      const currentUser = searchParams.get("company_user");
      const hasUserFilter = pageSettings?.user;
      const expectedStoreType = isStoreDocumentsPage ? 'store' : 'user';
      
      // First, ensure storeType is correct
      if (storeType !== expectedStoreType) {
        console.log("Setting storeType - storeType mismatch", { storeType, expectedStoreType });
        setStoreType(expectedStoreType);
        // Don't reset here, let the storeType change trigger the fetch
        // Then reset will happen on next render
        return;
      }
      
      // Reset only when we have a user filter in state but the URL does
      // not (coming back from a detail page with filters). An empty
      // result set is a valid state — resetting on it refetches and
      // loops forever when the list is genuinely empty.
      if (hasUserFilter && !currentUser) {
        console.log("Resetting document list - clearing user filter", { hasUserFilter, currentUser });
        resetDocumentList();
      }
    }
  }, [location.pathname, searchParams, storeType, resetDocumentList])
  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    documentData, setDocumentData,
    documentGroups,
    groupCollapse, setGroupCollapse,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    documentModal, setDocumentModal,
    selectedDocument, setSelectedDocument,

    handleGridChange,
    handleChange,
    handleSortChange,
    handleTablePageChange,
    handleGroupByChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleDocumentDetailPage,
    handleDateChange,
    handleClearAll,
    getDocumentList,

    documentType, setDocumentType,
    storeType, setStoreType,
    documentTypeLoading,

    resetDocumentList,
    getExportParams,
    isFilterDirty,

    documentStats,
    statsLoading,
    getDocumentStats,
    refreshDocuments,
    setDocumentArchived,
    applyFilterValues,
    appliedExpiryFilters,

  }), [documentData , documentGroups, groupCollapse, view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, documentModal, selectedDocument, documentType, storeType, documentTypeLoading, getExportParams, isFilterDirty, documentStats, statsLoading, appliedExpiryFilters]);

  return (
    <documentContext.Provider value={value}>
      {children}
    </documentContext.Provider>
  );
};